import React, { FC, useEffect } from 'react'

import { useSessionLanguage, useSessionTheme } from '@context/SessionSettingsContext'

import { mapToTradingViewLocale } from '@global/locale/Locale'

export const TradingViewBrokerReviewWidget: FC = () => {
  const locale = useSessionLanguage()
  const tradingViewLocale = mapToTradingViewLocale(locale)
  const theme = useSessionTheme()
  const isDark = theme === 'dark'

  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://www.tradingview-widget.com/widget/broker-reviews.js?locale=${tradingViewLocale}broker=tickmill`
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [tradingViewLocale])

  return React.createElement('tv-broker-reviews', {
    mode: 'carousel',
    broker: 'tickmill',
    theme: isDark ? 'dark' : 'light',
    lang: tradingViewLocale,
    transparent: true,
    'show-broker-name': true,
  })
}
